export default __webpack_public_path__ + "static/media/adv.d97f5ab6.jpg";